import React from 'react';
import { MessageCircle } from 'lucide-react';
import { WHATSAPP_NUMBER, WHATSAPP_MESSAGES } from '../../config/constants';

interface WhatsAppButtonProps {
  message?: string;
  service?: keyof typeof WHATSAPP_MESSAGES;
  className?: string;
  children?: React.ReactNode;
  floating?: boolean;
}

const WhatsAppButton: React.FC<WhatsAppButtonProps> = ({
  message,
  service,
  className = '',
  children,
  floating = false
}) => {
  const handleWhatsAppClick = () => {
    let finalMessage = message || WHATSAPP_MESSAGES.base;
    
    if (service && WHATSAPP_MESSAGES[service]) {
      finalMessage = `${WHATSAPP_MESSAGES.base} ${WHATSAPP_MESSAGES[service]}`;
    }
    
    // Clean the phone number - remove all non-digits except the leading +
    const cleanNumber = WHATSAPP_NUMBER.replace(/[^\d+]/g, '').replace('+', '');
    const whatsappUrl = `https://wa.me/${cleanNumber}?text=${encodeURIComponent(finalMessage)}`;
    window.open(whatsappUrl, '_blank');
    
    // Analytics tracking
    if (typeof gtag !== 'undefined') {
      gtag('event', 'whatsapp_click', {
        'service_type': service || 'general',
        'page_location': window.location.href
      });
    }
  };

  if (floating) {
    return (
      <div className="fixed bottom-6 right-6 z-50">
        <button
          onClick={handleWhatsAppClick}
          className="bg-teal hover:bg-teal/90 text-white p-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-teal/40 focus:ring-offset-2"
          aria-label="Contact us on WhatsApp"
        >
          <MessageCircle size={24} />
        </button>
      </div>
    );
  }

  return (
    <button
      onClick={handleWhatsAppClick}
      className={`inline-flex items-center gap-2 bg-teal hover:bg-teal/90 text-white font-medium px-6 py-3 rounded-lg transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-teal/40 focus:ring-offset-2 ${className}`}
    >
      {children ? (
        children
      ) : (
        <>
          <MessageCircle size={20} />
          Contact on WhatsApp
        </>
      )}
    </button>
  );
};

export default WhatsAppButton;
